// de strings for messages/studio.ts. Same keys and {variables} as en there.
import type { Dict } from "../index";

const studio: Dict = {
  "studio.title.none": "Erstelle ein Cover",
  "studio.title.one": "Lass {name} singen",
  "studio.title.many": "Lass sie singen",
  "studio.section.voice": "Stimme",
  "studio.section.whoSings": "Wer singt",
  "studio.section.count": "{n} von {max}",
  "studio.section.audio": "Audio",
  "studio.pickVoice": "Wähle eine Stimme",
  "studio.pickVoiceNote": "Über 100.000 Stimmen oder deine eigene",
  "studio.addVoice": "Stimme hinzufügen",
  "studio.whoSingsWhen": "Wer singt wann",
  "studio.sound": "Sound",
  "studio.video": "Video",
  "studio.video.off":
    "Lass deine Stimmen in einem Marble Run gegeneinander antreten",
  "studio.video.on": "Marble Run · 1 Münze",
  "studio.video.add": "Marble Run hinzufügen · 1 Münze",
  "studio.coins.unlimited": "Unbegrenzt Münzen mit Power",
  "studio.coins.one": "Noch {count} Münze",
  "studio.coins.other": "Noch {count} Münzen",
  "studio.done": "Fertig",
  "studio.remove": "Entfernen",
  "studio.cta.pickVoice": "Wähle zuerst eine Stimme",
  "studio.cta.addAudio": "Audio hinzufügen",
  "studio.cta.create": "Cover erstellen",
  "studio.auth.video": "Registriere dich, um ein Video zu erstellen",
  "studio.auth.audio": "Registriere dich, um dein Audio zu nutzen",
  "studio.auth.save": "Speichere dein Cover",
  "studio.upgrade.marbleRun":
    "Upgrade auf Creator, um Marble-Run-Videos zu erstellen",
  "studio.creatorReady": "Du hast Creator. Wähle deinen Marble Run.",
  "studio.maxVoices": "Du kannst maximal {max} Stimmen auswählen.",
  "studio.alreadyIn": "{name} ist schon in diesem Cover.",

  "studio.voices.search": "Stimmen suchen",
  "studio.voices.clear": "Suche löschen",
  "studio.voices.trending": "Angesagt",
  "studio.voices.recent": "Zuletzt verwendet",
  "studio.voices.mine": "Meine Stimmen",
  "studio.voices.music": "Musik",
  "studio.voices.cartoon": "Cartoons",
  "studio.voices.gaming": "Gaming",
  "studio.voices.anime": "Anime",
  "studio.voices.publicFigure": "Promis",
  "studio.voices.oftenWith": "Oft mit {name}",
  "studio.voices.pairedWith": "Oft kombiniert mit {name}",
  "studio.voices.add": "{name} hinzufügen",
  "studio.voices.change": "{name} ändern",
  "studio.voices.removeName": "{name} entfernen",
  "studio.voices.upTo": "Bis zu {max}",
  "studio.voices.makeDuet": "Mach ein Duett daraus",
  "studio.voices.uses": "{n}× genutzt",
  "studio.voices.noMatch": "Keine Stimmen passen zu dieser Suche.",
  "studio.voices.noMine": "Du hast noch keine trainierten Stimmen.",
  "studio.voices.noPairs":
    "Diese Woche noch keine Duette mit dieser Stimme. Probier Angesagt.",
  "studio.empty": "Hier ist noch nichts.",
  "studio.change": "Ändern",

  "studio.who.auto": "Automatisch",
  "studio.who.manual": "Selbst wählen",
  "studio.who.chose.one": "Selbst gewählt · {n} Teil",
  "studio.who.chose.other": "Selbst gewählt · {n} Teile",
  "studio.who.autoExplain":
    "Die Stimmen wechseln sich ab, wo immer der Gesang wechselt.",
  "studio.who.autoCanChoose":
    "Willst du mitbestimmen? Mit Selbst wählen legst du fest, wer welchen Teil singt.",
  "studio.who.autoNeedsFile":
    "Selbst wählen geht nur mit einem Upload, einer Aufnahme oder einem Song aus der Bibliothek.",
  "studio.who.loading": "Song wird geladen…",
  "studio.who.failed":
    "Wir konnten diesen Song hier nicht abspielen, deshalb entscheidet Jammable.",
  "studio.who.pause": "Pause",
  "studio.who.playSong": "Song abspielen",
  "studio.who.partLabel": "{name}, {start} bis {end}",
  "studio.who.moveSwap": "Verschieben, wo die Stimmen wechseln",
  "studio.who.part": "Teil {n}",
  "studio.who.play": "Abspielen",
  "studio.who.split": "Teilen",
  "studio.who.takeOver": "Wer übernimmt diesen Teil?",
  "studio.who.before": "Der Teil davor",
  "studio.who.after": "Der Teil danach",
  "studio.who.sungBy": "Gesungen von",
  "studio.who.hint":
    "Tippe auf einen Teil, um ihn anzuhören und zu wählen, wer ihn singt. Zieh die weißen Griffe, um zu verschieben, wo die Stimmen wechseln.",
  "studio.who.tooShort":
    "Jeder Teil muss mindestens {secs} Sekunden lang sein.",

  "studio.song.upload": "Hochladen",
  "studio.song.library": "Bibliothek",
  "studio.song.tts": "Text eingeben",
  "studio.song.generate": "KI-Song",
  "studio.song.mic": "Aufnehmen",
  "studio.song.sources": "Woher der Song kommt",
  "studio.song.rights": "Lade nur Audio hoch, für das du die Rechte hast.",
  "studio.song.search": "Songs suchen",
  "studio.song.searchUploads": "Deine Uploads durchsuchen",
  "studio.song.searchLibrary": "Song-Bibliothek durchsuchen",
  "studio.song.popular": "Beliebt",
  "studio.song.yourUploads": "Deine Uploads",
  "studio.song.noMatch": "Keine Songs passen zu dieser Suche.",
  "studio.song.noUploads": "Du hast noch nichts hochgeladen.",
  "studio.song.picked": "Ausgewählt",
  "studio.source.generate": "KI-generiert",
  "studio.source.upload": "Hochgeladen",
  "studio.source.library": "Aus der Bibliothek",
  "studio.source.mic": "Aufgenommen",
  "studio.source.tts": "Text zu Sprache",

  "studio.tts.what": "Was sollen sie sagen?",
  "studio.tts.placeholder": "Schreib, was sie sagen sollen...",
  "studio.tts.baseVoice": "BASISSTIMME",
  "studio.tts.accent": "AKZENT",
  "studio.tts.delivery": "TONFALL",
  "studio.tts.use": "Diesen Text verwenden",
  "studio.tts.empty": "Bitte gib einen Text ein.",
  "studio.tts.tooLong": "Der Text überschreitet das Limit von {max} Zeichen.",
  "studio.tts.gender.female": "Weiblich",
  "studio.tts.gender.male": "Männlich",
  "studio.tts.accent.US": "Amerikanisch",
  "studio.tts.accent.GB": "Britisch",
  "studio.tts.accent.FR": "Französisch",
  "studio.tts.accent.DE": "Deutsch",
  "studio.tts.accent.ES": "Spanisch",
  "studio.tts.accent.IT": "Italienisch",
  "studio.tts.accent.KR": "Koreanisch",
  "studio.tts.accent.AU": "Australisch",
  "studio.tts.accent.JP": "Japanisch",
  "studio.tts.expr.default": "Normal",
  "studio.tts.expr.whispered": "Geflüstert",
  "studio.tts.expr.happy": "Fröhlich",
  "studio.tts.expr.sad": "Traurig",
  "studio.tts.expr.angry": "Wütend",
  "studio.tts.expr.shouting": "Schreiend",
  "studio.tts.expr.terrified": "Verängstigt",

  "studio.ai.style": "WÄHLE EINEN STIL ODER BESCHREIB EINEN",
  "studio.ai.styleLabel": "Song-Stil",
  "studio.ai.stylePlaceholder":
    "z. B. fröhlicher Sommer-Pop, Akustikgitarre, eingängiger Refrain",
  "studio.ai.lyrics": "Songtext",
  "studio.ai.lyricsPlaceholder":
    "Leer lassen, damit die KI den Text schreibt, oder:\n\n[Verse 1]\nSchreib hier deinen Songtext...\n\n[Chorus]\nNutze die Tags [Verse], [Chorus] und [Bridge] für die Struktur",
  "studio.ai.ownLyrics":
    "+ Eigenen Songtext schreiben (sonst schreibt ihn die KI)",
  "studio.ai.use": "Diesen Song verwenden",
  "studio.ai.noStyle": "Beschreib den Stil des Songs.",
  "studio.ai.styleTooLong":
    "Die Stilbeschreibung muss unter {max} Zeichen bleiben.",
  "studio.ai.lyricsTooLong": "Der Songtext muss unter {max} Zeichen bleiben.",
  "studio.ai.genre.pop": "Pop",
  "studio.ai.genre.trap": "Trap",
  "studio.ai.genre.rnb": "R&B",
  "studio.ai.genre.indie": "Indie",
  "studio.ai.genre.kpop": "K-Pop",
  "studio.ai.genre.edm": "EDM",
  "studio.ai.genre.lofi": "Lo-Fi",
  "studio.ai.genre.country": "Country",
  "studio.seo.title": "Cover erstellen | Jammable",
  "studio.seo.description":
    "Wähle eine Stimme, füge Audio hinzu, für das du die Rechte hast, und erstelle ein KI-Cover auf Jammable.",
};

export default studio;
